import { environment } from '@env/environment';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export function customMissingTranslationHandler(): MissingTranslationHandler {
    return {
        handle: (params: MissingTranslationHandlerParams): string => {
            if (environment.production === false) {
                console.warn(`Missing translation for key: ${params.key}`);
            }
            return params.key;
        },
    };
}
